const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const formActions = require('react-redux-form').actions;
const optionsActions = require('actions/optionsActions');
const SuggestSimpleList = require('components/suggestList/suggestSimpleList').SuggestSimpleList;
const PropTypes = require('prop-types');
import { formatText } from 'core/i18n';

class SearchByCode extends React.Component {
    constructor(props) {
        super(props);

        this.getProfessionsWorkfor = this.getProfessionsWorkfor.bind(this);
        this.onHandleUpdate = this.onHandleUpdate.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { options, optionsActions, sector } = this.props;
        if (options.get('professionsWorkforSelfEmployedCode').size === 0) {
            optionsActions.getProfessionsWorkfor('01', sector, true);
        }
    }

    getProfessionsWorkfor() {
        const professionsWorkfor = [];
        this.props.options.get('professionsWorkforSelfEmployedCode').map(function (value) {
            professionsWorkfor.push(value.toObject());
        });

        return professionsWorkfor;
    }

    onHandleUpdate() {
        const { userProfile, handleSave } = this.props;
        if (handleSave) {
            handleSave('profession', {
                id: userProfile['profession_id'],
            });
        }
    }

    render() {
        const { userProfile, title, subTitle, disabled } = this.props;
        return (
            <div className="search-for-profession">
                <SuggestSimpleList
                    profileModel="userProfile.profession_id"
                    name="employed_profession"
                    label={title}
                    subTitle={subTitle}
                    placeholder={formatText('cnaeOrCno-placeholderCode')}
                    disabledWhenSelected={false}
                    optionsList={this.getProfessionsWorkfor()}
                    isUpdated={this.onHandleUpdate}
                    focusAnimated
                    minSearchLength={1}
                    disabled={disabled}
                    validations={{
                        required: () => userProfile.profession_id && userProfile.profession_id.length,
                    }}
                    {...this.props}
                />
            </div>
        );
    }
}

module.exports.constructor = SearchByCode;
module.exports.SearchByCode = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
    })
)(SearchByCode);

SearchByCode.defaultProps = {
    title: formatText('cnaeOrCno-searchByCodeTitle'),
    subTitle: '',
};

SearchByCode.propTypes = {
    sector: PropTypes.string,
    options: PropTypes.object,
    optionsActions: PropTypes.object,
    title: PropTypes.string,
    subTitle: PropTypes.string,
};
